import { webApi } from "../../../../core/http/httpThunks";
import { EtfSummaryApiResponse } from "../types";

export const getEtfSummaryApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EtfSummaryApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getEtfSummaryApi;
